import { ReactNode } from 'react'
import { MetaTagsInterface } from 'lib/routing/MetaTags'
import { CustomHead } from '../CustomHead'
import type { SchemaOrgItem } from '../CustomHead/Schemas/SchemaWrapper'

interface Props {
	metaTags: MetaTagsInterface
	schemas?: Array<SchemaOrgItem>
	children: ReactNode
}

export const MinimalLayout = ({ metaTags, children }: Props) => (
	<>
		<CustomHead tags={metaTags} />
		{children}
	</>
)
